import { Component, Input } from "@angular/core";
import { Team } from "@common/ADAPT.Common.Model/organisation/team";

@Component({
    selector: "adapt-team-inactive-badge",
    templateUrl: "./team-inactive-badge.component.html",
    styles: `:host { display: contents; }`,
    standalone: false,
})
export class TeamInactiveBadgeComponent {
    @Input() public team?: Team;
    @Input() public hasActiveChildren = false;
    @Input() public badgeClass = "";
}
